import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
@Component({
  selector: 'page-servis-hareket',
  templateUrl: 'servis-hareket.html',
})
export class ServisHareketPage {
  serviskaydi: any = { ID: -1 };
  tarih: any;
  vWKayit: any = {};
  islemyapansabit = this.ortak.storagePersonelGetir.Name;
  YapilanServis: any = { ID: -1, YapilanIslem: "", Maliyet: "", Aciklama: "", IslemYapan: "", ServiceID: "" };
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    if (navParams.get("vWKayit") != null) {
      this.vWKayit = navParams.get("vWKayit");
      var data = new FormData();
      data.append("Servis_id", this.vWKayit.ID);
      this.bllOrtak.islem(data, "ServisGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.serviskaydi = Sonuc.SonucObject;
        this.YapilanServis.ServiceID = this.serviskaydi.ID;
        this.YapilanServis.MusteriID=this.serviskaydi.CariID;
      });
    }
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  kaydet() {
    if(this.boslukKontrol())
    {
      if(this.YapilanServis.IslemYapan==null||this.YapilanServis.IslemYapan=="")
      {
        this.YapilanServis.IslemYapan=this.ortak.storagePersonelGetir.Name;
        
      }
      var formData = new FormData();
      formData.append("hareket_json", JSON.stringify(this.YapilanServis));
      this.bllOrtak.islem(formData, "ServisHareketEkle", "", false).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        this.viewCtrl.dismiss();
  
      })
    }
   

  }
  boslukKontrol() {
    var mesaj = "";
    if (this.YapilanServis.YapilanIslem == null || this.YapilanServis.YapilanIslem == "") {
      mesaj = mesaj + "Lütfen yapılan işlemi giriniz. <br/>";
    }
  else  if (this.YapilanServis.Maliyet == null || this.YapilanServis.Maliyet == "") {
      mesaj = mesaj + "Lütfen maliyet giriniz. <br/>";
    }
  
    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/servis-hareket/servis-hareket.ts